import { Injectable } from '@angular/core';

import { Changelog } from 'app/models';
import { environment } from 'environments/environment';

import { HttpService } from './http.service';

const changelogUrl = siterecordId => `${environment.apiUrl}/siterecordchangelogs/siterecord/${siterecordId}`;

@Injectable()
export class ChangelogService {
  constructor(private readonly httpService: HttpService) {}

  getChangelogForSiterecord(siterecordId: number) {
    return this.httpService.get<Changelog[]>(changelogUrl(siterecordId));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/changelog.service.ts